<app-standard-data-table (gridRequested)="gridRequested($event)" [source]="events" [sorts]="[{ prop: 'timestamp', dir: 'desc' }]" [columns]="columns$ | async" [noRecordsMessage]="noRecords"></app-standard-data-table>

<ng-template #eventSeverityTemplate let-row="row">
    <app-event-severity [severity]="row?.severity"></app-event-severity>
</ng-template>

<ng-template #startedTemplate let-row="row">
    {{ row?.timestamp | date: 'yyyy-MM-dd HH:mm' }}
</ng-template>

<ng-template #endedTemplate let-row="row">
    {{ row?.ceasedAt | date: 'yyyy-MM-dd HH:mm' }}
</ng-template>

<ng-template #eventListHeaderTemplate>
    @if (eventListType !== 'Asset') {
        @if (eventListType !== 'EdgeDevice') {
            <span>{{ 'devices.name.singular' | translation | async }} / </span>
        }
        @if (eventListType !== 'Asset') {
            <span>{{ 'assets.name.singular' | translation | async }}</span>
        }
    }
</ng-template>

<ng-template #eventListTemplate let-row="row">
    @if (eventListType !== 'Asset') {
        @if (eventListType !== 'EdgeDevice') {
            <span placement="left" ngbTooltip="{{ row?.edgeDeviceName }}" (click)="navigateToEdgeDevice(row?.edgeDeviceId)" class="fas fa-microchip default-icon-color fa-lg me-2"></span>
        }
        @if (eventListType !== 'Asset') {
            <span placement="left" ngbTooltip="{{ row?.assetName }}" (click)="navigateToAsset(row?.edgeDeviceId, row?.assetId)" class="fas fa-plug default-icon-color"></span>
        }
    }
</ng-template>

<ng-template #noRecords>
    <div class="vertical-centering default-icon-color">
        <i class="fas fa-info-circle fa-7x"></i>
        <div class="no-records-message">{{ 'events.noRecordsMessage' | translation | async }}</div>
        <div class="no-records-message-detail">{{ 'events.NoRecordsMessageDetail' | translation | async }}</div>
    </div>
</ng-template>
